import getActiveInactiveStatus from '@product-framework/utils/getActiveInactiveStatus';
import { truncateText } from '@ui-framework/index';

import { Link } from 'react-router-dom';

function name(original) {
  return (
    <Link to={`/labormatrices/edit/${original?.id}`}>
      {original?.name || ''}
    </Link>
  );
}

function description(original) {
  return truncateText(original?.description);
}

function status(original) {
  return getActiveInactiveStatus(original?.status);
}

function isDefaultLaborMatrix(original) {
  return original?.isDefaultLaborMatrix ? 'Default' : '';
}

export { name, status, description, isDefaultLaborMatrix };
